import React from 'react';
import { Box, Typography } from '@mui/material';

const InfoDetail = ({
  label,
  value,
  direction = 'row',
  gap = 2,
  width = { xs: '100%', md: '50%' },
  labelColor = '#666',
  valueColor = 'text.primary',
  alignItems = 'center',
  justifyContent,
  labelVariant = 'labelD',
  valueVariant = 'body1',
}) => {
  const displayValue =
    value === null || value === undefined || String(value).trim() === ''
      ? '-'
      : String(value);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: direction,
        gap,
        alignItems,
        justifyContent,
        width: direction === 'row' ? width : '100%',
      }}
    >
      <Typography
        variant={labelVariant}
        sx={{ color: labelColor, minWidth: direction === 'row' ? { xs: '50%' } : 'auto' }}
      >
        {label}
      </Typography>
      <Typography variant={valueVariant} sx={{ color: valueColor }}>
        {displayValue}
      </Typography>
    </Box>
  );
};

export default InfoDetail;
